module.exports = __webpack_public_path__ + "img/sm-x-old2.7a640984.svg";